import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { loadEvent } from '~/state/modules/events'
import { Typography } from '@material-ui/core'
import {
  createSector,
  createSeats,
  loadSector,
  loadSeats
} from '~/state/modules/planimetry'
import { PaperContainer } from '~/views/shared'
import { SectorForm } from '../SectorForm'
import { ROUTES } from '~/views/routes'
import { PositionDescriptor, SEATS_STATUS } from 'config/constants'
import history from '~/config/history'
import { cloneSeatsGrid } from '../SeatsDistribution/SeatSettings/lib/utils'
import { showSnackbarError, showSnackbarSuccess } from 'views/utils/snackbar'
import { cleanHexColor } from 'views/utils/functions'

export const SectorClonePage = ({ match, onSuccess }) => {
  const { pendingCreateLayout, sector, pendingCreateSeats, seats } =
    useSelector((state) => state.planimetry)
  const { eventId, layoutId, sectorId } = match.params
  const { event } = useSelector((state) => state.events)

  const dispatch = useDispatch()

  useEffect(() => {
    async function fetchData() {
      await dispatch(loadEvent(eventId))
      await dispatch(loadSector(sectorId))
      await dispatch(loadSeats(sectorId))
    }

    fetchData()
    // eslint-disable-next-line
  }, [])

  const createSeatsPayload = (newSectorId, seats, newRows, newColumns) => {
    const updatedSeats = cloneSeatsGrid(newRows, newColumns, seats).map(
      (seat) => ({
        Column: seat.column,
        Row: seat.row,
        IsSeat: true,
        Status: SEATS_STATUS[seat.status],
        Id: seat.id || null
      })
    )
    return {
      SectorId: newSectorId,
      Column: newColumns,
      Row: newRows,
      Seats: updatedSeats
    }
  }

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setSubmitting(true)
      const sector = await dispatch(createSector(values))
      const payload = createSeatsPayload(
        sector.Id,
        seats,
        values.Row,
        values.Column
      )
      await dispatch(createSeats(payload))
      onSuccess(eventId, layoutId)
      showSnackbarSuccess('Sector Creado!')
    } catch (error) {
      showSnackbarError(error)
    } finally {
      setSubmitting(false)
    }
  }

  const values = {
    SectorName: sector?.Name || '',
    Column: sector?.Column || '',
    ColumnDescriptor: sector?.ColumnDescriptor || PositionDescriptor.Numeric,
    Row: sector?.Row || '',
    RowDescriptor: sector?.RowDescriptor || PositionDescriptor.Numeric,
    ImageId: sector?.ImageId || '',
    ImageFile: sector?.ImageCdnUrl || null,
    LayoutId: layoutId,
    Color: cleanHexColor(sector?.Color)
  }

  return (
    <>
      {event && (
        <Typography variant='h6' style={{ paddingInline: 8, paddingBottom: 8 }}>
          {`${event?.Title} (${event?.Id})`}{' '}
        </Typography>
      )}
      <PaperContainer title='Clonación de Sector'>
        <SectorForm
          values={values}
          actionText='Crear'
          handleSubmit={handleSubmit}
          actionPending={pendingCreateLayout || pendingCreateSeats}
          onCancel={() =>
            history.push(
              ROUTES.ADMIN.EVENTS.SECTORS.INDEX.replace(
                ':eventId',
                eventId
              ).replace(':layoutId', layoutId)
            )
          }
        />
      </PaperContainer>
    </>
  )
}

export default SectorClonePage
